<template>
  <span 
    :id="id"
    :data-type="type"
    :data-url="url"
    :data-pk="pk"
    :data-showbuttons="showButton"
    :data-inputclass="className"
    :data-mode="mode"
    :data-value="value"
    :data-emptytext="emptyText"
    :data-title="title"/>
</template>

<script>
import '../../../../../../node_modules/x-editable/dist/bootstrap3-editable/js/bootstrap-editable.min';

export default {
    props: {
        pk: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            default: 'text',
        },
        url: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'inline',
        },
        showButton: {
            type: String,
            default: 'false',
        },
        // eslint-disable-next-line vue/require-prop-types
        value: {
            default: null,
        },
        className: {
            type: String,
            default: 'w-sm',
        },
        submitMethod: {
            type: String,
            default: 'put',
        },
        required: {
            type: Boolean,
            default: true,
        },
        validationType: {
            type: String,
            default: 'text',
        },
        name: {
            type: String,
            required: true,
        },
        params: {
            type: Object,
            default() {
                return {};
            },
        },

        emptyText: {
            type: String,
            default: 'Not Set',
        },
    },
    data() {
        return {
            editable: null,
            elem: null,
        };
    },

    computed: {
        ajaxOptions() {
            return {
                type: this.submitMethod,
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest',
                },
            };
        },

        id() {
            return this.name + '_' + this.pk;
        },

        capitalizedName() {
            let capitalizedName = this.name.replace(/\b\w/g, l => {
                return l.toUpperCase();
            });
            return capitalizedName.replace('_', ' ');
        },
    },

    created() {},

    mounted() {
        if (this.editable) return;

        let elem = this.$el;
        let $elem = jQuery(elem);
        this.elem = $elem;

        this.editable = $elem.editable({
            ajaxOptions: this.ajaxOptions,
            params: this.parameters,
            validate: this.validate,
            success: this.onSuccess,
            display: this.displayValue,
        });
    },

    beforeDestroy() {
        if (this.elem) {
            this.elem.remove();
            this.editable = null;
        }
    },

    methods: {
        parameters(params) {
            let parameters = {};
            parameters[this.name] = params.value;

            return Object.assign(parameters, this.params);
        },

        displayValue(value) {
            if (this.validationType == 'numeric' && value !== '') {
                this.elem.text(parseFloat(value));
            }

            if (this.validationType == 'decimal' && value !== '') {
                this.elem.text(numeral(value).format('0,0.00'));
            }

            if (this.validationType == 'text' && value !== '') {
                this.elem.text(value);
            }
        },

        validate(val) {
            if (this.required && $.trim(val) == '') {
                return this.capitalizedName + ' is required';
            }

            if (this.validationType === 'numeric') {
                if (!this.isNumeric(val)) {
                    return this.capitalizedName + ' must be a number';
                }
            }

            if (this.validationType === 'decimal') {
                if (!this.isNumeric(val)) {
                    return this.capitalizedName + ' must be a number';
                }

                if (!this.isValidDecimal(val)) {
                    return (
                        this.capitalizedName + ' may contain 2 decimal points'
                    );
                }
            }
        },

        onSuccess(res, newValue) {
            this.$emit('success', res);
        },

        isNumeric(val) {
            if (_.isNaN(parseFloat(val))) {
                return false;
            }

            return true;
        },

        isValidDecimal(val) {
            if (this.countDecimals(val) > 2) {
                return false;
            }

            return true;
        },

        countDecimals(val) {
            if (Math.floor(val) == val) return 0;

            return val.toString().split('.')[1].length || 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vendor/x-editable/editable.vue